const MIN_ZOOM = 4;
export default MIN_ZOOM;
